import { Checkbox, Field, Label } from '@headlessui/react'
import { _t } from "core/language";

type TCCheckbox = {
  className?: string;
  onChange: (value: boolean) => void;
  checked: boolean;
  label?: string;
  labelClassName?: string;
  disabled?: boolean;
  rounded?: boolean; // checkbox nhưng hình tròn
}

export default function CCheckbox({
  className,
  onChange,
  checked,
  label,
  labelClassName = 'font-medium',
  disabled,
  rounded,
}: TCCheckbox) {

  const roundedClassNAmes = rounded ? 'rounded-full' : 'rounded'

  return (
    <Field className={`flex items-center gap-2 ${className}`}>
      <Checkbox
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={`
          cursor-pointer outline-none group w-[20px] h-[20px] relative size-4 bg-white border
          data-[checked]:bg-primary data-[checked]:border-0 data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50 data-[disabled]:bg-gray-400
          ${roundedClassNAmes}
        `}
      >
        {rounded ? (
          <span
            className={`
              absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2
              w-[8px] h-[8px] bg-white border rounded-full
              opacity-0 group-data-[checked]:opacity-100
            `}
          ></span>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-[20px] h-[20px] stroke-white opacity-0 group-data-[checked]:opacity-100"
            fill="none"
            viewBox="-4 -2 20 12"
          >
            <path
              stroke="white"
              strokeWidth={2}
              strokeLinecap="round"
              d="M1.2998 3.5L4.7998 7L10.7998 1"
            />
          </svg>
        )}
      </Checkbox>
      {label && <Label className={`text-[14px] ${labelClassName} cursor-pointer`} 
        dangerouslySetInnerHTML={{__html: _t(label) }} />}
    </Field>
  )
}
